module.exports = __webpack_public_path__ + "img/bth_bed2_left_tunbu_sel.6bdfbc4b.png";